import { object, string, number, date, InferType, array } from "yup";

const educationInputs = [
  {
    name: "schoolName",
    label: "School Name *",
    type: "text",
    placeholder: "Enter School Name",
  },
  {
    name: "schoolCity",
    label: "School City *",
    type: "text",
    placeholder: "Enter School City",
  },
  {
    name: "schoolState",
    label: "School State *",
    type: "text",
    placeholder: "Enter School State",
  },
  {
    name: "schoolZip",
    label: "School Zip *",
    type: "text",
    placeholder: "Enter School Zip",
  },
  {
    name: "startDate",
    label: "Start Date *",
    type: "date",
    placeholder: "MM/DD/YYYY",
  },
  {
    name: "endDate",
    label: "End Date *",
    type: "date",
    placeholder: "MM/DD/YYYY",
  },
];

const validationSchema = object().shape({
  schoolName: string()
    .required("School name is required")
    .min(2, "Must be a mininum of 2 characters")
    .max(100, "Character max met"),
  schoolCity: string()
    .required("School city is required")
    .min(2, "Must be a mininum of 2 characters")
    .max(100, "Character max met"),
  schoolState: string()
    .required("School state is required")
    .max(2, "Enter 2 character State identifier")
    .matches(
      /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
          'State can only contain letters'
      ),
  schoolZip: string()
    .min(5, "Must be at least 5 characters")
    .required("School zip is required"),
  startDate: string()
    .min(10, "Enter in the following format MM/DD/YYYY")
    .max(10)
    .required("Start date is required"),
  endDate: string()
    .min(10, "Enter in the following format MM/DD/YYYY")
    .max(10)
    .required("End date is required")
});

const handleValidatations = (values) => {
  let errors = {};

  // Validate startDate is not in the future
  if (values.startDate && values.startDate !== "") {
    const startDate = new Date(values.startDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (startDate > today) {
      errors.startDate = "Start date cannot be in the future";
    }
  }

  // Validate endDate is not in the future
  if (values.endDate && values.endDate !== "") {
    const endDate = new Date(values.endDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (endDate > today) {
      errors.endDate = "End date cannot be in the future";
    }
  }

  // Validate endDate is after startDate
  if (values.startDate && values.endDate) {
    const startDate = new Date(values.startDate);
    const endDate = new Date(values.endDate);
    if (endDate < startDate) {
      errors.endDate = "End date must be after start date";
    }
  }

  if (values.schoolZip && !/^[0-9]+$/i.test(values.schoolZip)) {
    errors.schoolZip = "Must be all numeric values";
  }
  return errors;
};

export { educationInputs, validationSchema, handleValidatations };
